import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";

const useModuleListing = () => {
  const { authData } = useSelector((state) => state.loginSlice);
  const [modules, setModules] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [modulesPerPage, setModulesPerPage] = useState(10);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [selectedModule, setSelectedModule] = useState({});
  const [groupBy, setGroupBy] = useState("modules");
  const [activeIndex, setActiveIndex] = useState(null);
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
    let value = e.target.value;

    if (value.startsWith(" ")) return;
    const isValid = /^[a-zA-Z0-9 ]*$/.test(value);

    if (!isValid) {
      return;
    }
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handlePageSizeChange = (e) => {
    setModulesPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const fetchModules = async () => {
    try {
      setLoader(true);
      let url = `${endpoint.GET_MODULES}?pageNumber=${currentPage}&pageSize=${modulesPerPage}&groupBy=${groupBy}`;
      if (searchTerm) {
        url += `&search=${searchTerm}`;
      }
      const response = await apiHandler({
        url: url,
        method: "GET",
        authToken: authData,
        dispatch,
      });

      if (response.data.success) {
        const modules = response.data.data.modules;
        setModules(modules);
        setTotalCount(response.data.data?.totalCount);
      }
    } catch (error) {
   
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTerm(searchTerm);
    }, 500); // Debounce delay (500ms)

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm]);

  // Trigger search only when debouncedTerm updates

  useEffect(() => {
    fetchModules();
  }, [currentPage, modulesPerPage, debouncedTerm, groupBy]);

  return {
    handlePageClick,
    handlePageSizeChange,
    handleSearch,
    modules,
    totalCount,
    searchTerm,
    modulesPerPage,
    currentPage,
    openCreateModal,
    setOpenCreateModal,
    selectedModule,
    setSelectedModule,
    fetchModules,
    groupBy,
    setGroupBy,
    activeIndex,
    toggleAccordion,
    loader,
  };
};

export default useModuleListing;
